<template>
  <PrimaryNavigation
    route-name-for-items="analysis"
    resource="projects"
    name-item-in-query="project"
    list-dispatch="projectStore/getList"
    list-getter="projectStore/getList"
    :static-route-query="{}"
    class="navigation"
    route-mode="params"
    :dispatch-params="{ groupAccessOnly: 'with' }"
    ref="navigation"
  >
    <template v-slot:footer>
      <AnalysisGroupNavigation></AnalysisGroupNavigation>
    </template>
  </PrimaryNavigation>
</template>

<script>
import PrimaryNavigation from "../common/navigation/PrimaryNavigation";
import AnalysisGroupNavigation from "./AnalysisGroupNavigation";
export default {
  name: "AnalysisNavigation",
  components: {
    PrimaryNavigation,
    AnalysisGroupNavigation
  },
  watch: {
    "$route.query": {
      handler: function(s, d) {
        if (d.group_id && s.group_id) {
          this.$refs.navigation.drawer = !this.$vuetify.breakpoint.mdAndDown;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
